/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'close-all': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M511.999 1024C229.232 1024 0 794.766 0 511.997 0 229.23 229.232 0 511.999 0 794.768 0 1024 229.23 1024 511.997 1024 794.766 794.768 1024 511.999 1024zm0-959.998c-247.42 0-448 200.577-448 447.997 0 247.422 200.577 448 448 448 247.424 0 448.001-200.578 448.001-448C960 264.576 759.421 64.002 512 64.002zm45.435 448.177l135.583 135.582c12.497 12.499 12.497 32.757 0 45.256-12.497 12.5-32.757 12.5-45.254 0L512.177 557.432 375.67 693.939c-12.597 12.59-33.016 12.59-45.61 0-12.596-12.595-12.596-33.014 0-45.609l136.508-136.51-135.585-135.585c-12.5-12.497-12.5-32.757 0-45.252 12.497-12.501 32.755-12.501 45.254 0l135.588 135.585L649.34 329.054c12.593-12.598 33.015-12.598 45.61 0 12.594 12.593 12.594 33.015 0 45.606L557.435 512.18z"/>'
  }
})
